import axios from "axios";

// Netplus "Complaints" module — the daily CSV/Excel upload. GET reads live via
// RTK Query (appApi.js). Auth + x-project-id ride on the global axios
// interceptor; every request carries ?partnerCode= from the caller.

const API = `${
  process.env.REACT_APP_API_URL || "http://localhost:5001"
}/api/netplus/complaints`;

export const uploadComplaintSheet = ({ file, snapshotDate, partnerCode }) => {
  const fd = new FormData();
  fd.append("file", file);
  fd.append("partnerCode", partnerCode);
  if (snapshotDate) fd.append("snapshotDate", snapshotDate);
  return axios.post(`${API}/uploads`, fd, {
    headers: { "Content-Type": "multipart/form-data" },
    params: { partnerCode },
  });
};

// Mark a complaint resolved by an employee (or clear it with resolved:false).
export const resolveComplaintApi = (id, { resolvedBy, resolved }, partnerCode) =>
  axios.patch(
    `${API}/${id}/resolve`,
    { resolvedBy, resolved },
    { params: { partnerCode } },
  );

// A3 — employee logs a genuine reason on an open/reopened complaint.
export const addComplaintNoteApi = (id, text, partnerCode) =>
  axios.patch(`${API}/${id}/note`, { text }, { params: { partnerCode } });

// A3 — super-admin approves that reason; cancels the reopened penalty.
export const greenFlagComplaintApi = (id, { greenFlagged, note }, partnerCode) =>
  axios.patch(
    `${API}/${id}/green-flag`,
    { greenFlagged, note },
    { params: { partnerCode } },
  );
